import React from 'react';
import { Card, CardContent} from '@material-ui/core';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepContent from '@material-ui/core/StepContent';
import CuitForm from './CuitForm';
import EstablishmentForm from './EstablishmentForm';
import AccountForm from './AccountForm';
import { makeStyles } from '@material-ui/core/styles';
import {MessageBox} from "./MessageBox";
import StepButton from "@material-ui/core/StepButton";
import mail from '../../images/mail-icon.png';
import {Link} from '@material-ui/core';
import { URL_BACKOFFICE } from '../../index';
import ProductRequest from "../../models/request/ProductRequest";
import {Establishment} from "../../models/Establishment";
import OtpModal from "../Otp/OtpModal";

const colorLightBlue = "#30c2c2";

const useStyles = makeStyles({
    root: {
        borderRadius: 18,
        boxShadow: '0px 5px 9px 1px rgba(0,0,0,0.83)',
    },
    title: {
        color: 'rgb(30, 67, 132)',
        textAlign: 'left',
        marginTop: 20,
        marginLeft: 35,
        width: 600,
        fontSize: 28,
    },
    subtitle: {
        color: 'rgb(30, 67, 132)',
        textAlign: 'left',
        marginTop: 10,
        marginLeft: 35,
        width: 600,
        fontSize: 16,
    },
    linkStyle2: {
        color: colorLightBlue,
        padding: "5px"
    },
});

const initialProductRequest: ProductRequest =  {
    code: "",
    brands: []
}

const initialEstablishments: Establishment[] =  [{
    code: "",
    terminals: [],
    brands: [],
    business_name : "",
    address: "",
    city: "",
    zip_code: ""
}]


const StepperForm : React.FC = () => {

    const [cuit , setCuit] = React.useState('');
    const [establishments , setEstablishments] = React.useState(initialEstablishments);
    const [stepEstablishmentComplete, setStepEstablishmentComplete] = React.useState(false);
    const [productRequest , setProductRequest] = React.useState(initialProductRequest);
    const [activeStep, setActiveStep] = React.useState(0);
    const [establishmentCode, setEstablishmentCode] = React.useState("")
    const [email, setEmail] = React.useState("")
    const [showModal, setShowModal] = React.useState(false)
    const steps = getSteps();

    function getSteps() {
        return ['Ingresá tu CUIT', 'Ahora vamos a validar tu identidad', 'Completá los datos de la cuenta'];
    }


    function getStepContent(step: number) {
        switch (step) {
        case 0:
            return <CuitForm handleNext={ handleNextWithCuit } setEstablishments={setEstablishments}/>
        case 1:
            return <EstablishmentForm
               cuit={ cuit }
               establishments={establishments}
               setEstablishments={setEstablishments}
               stepEstablishmentComplete={stepEstablishmentComplete}
               handleNext={ handleNextWithECommerce }
               ecoNumberEntered={Number(establishmentCode)}
            />
            case 2:
            return <AccountForm cuit={cuit} handleNext={ handleNext } productRequest={productRequest} establishments={establishments}/>
        case 3:
            return `Try out different ad text to see what brings in the most customers,
                and learn how to enhance your ads using features like ad extensions.
                If you run into any problems with your ads, find out how to tell if
                they're running and how to resolve approval issues.`;
        default:
        return 'Unknown step';
        }
    }

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleNextWithCuit = (cuit: string, establishments: any) => {
        setCuit(cuit);
        setEstablishments(establishments)
        handleNext();
    };

    const handleNextWithECommerce = (productRequest: ProductRequest) => {
        setProductRequest(productRequest);
        setStepEstablishmentComplete(true);
        handleNext();
    };

    const handleStep = (step: number) => () => {
        if ((step == 1 && activeStep == 2) || (step==2 && activeStep==1  && stepEstablishmentComplete == true)) {
            setActiveStep(step);
        }
    };

    const isStepCompleted = (step: number) => {
        return ( activeStep > step )
      };

    const goToBackoffice = () => {
        window.location.replace(URL_BACKOFFICE);
        return;
    }


    const classes = useStyles();

    return (
        <Card className={classes.root}>
            <CardContent>
                <div className={classes.title}>Creá tu cuenta Payway para ventas online y hacé crecer tu negocio.</div>
                <div className={classes.subtitle}>Si tu comercio ya fue dado de alta en Cuenta Payway, podes comenzar a operar ingresando 
                    <Link
                        href={URL_BACKOFFICE}
                        onClick={goToBackoffice}
                        underline='hover'
                        className={classes.linkStyle2}>
                        aquí
                    </Link>
                </div>
                <div className={classes.subtitle}>Para crear tu cuenta, tu comercio tiene que estar adherido</div>
                <div className={classes.subtitle}>a Payway para vender por internet.</div>
                <Stepper nonLinear activeStep={activeStep} orientation="vertical">
                        {steps.map((label, index) => {

                        const stepProps: { completed?: boolean } = {};
                        
                        stepProps.completed = isStepCompleted(index);

                        return (<Step key={label} {...stepProps} >
                            <StepButton
                                onClick={handleStep(index)}>
                                {label}
                            </StepButton>
                            <StepContent>
                                {getStepContent(index)}

                            </StepContent>
                        </Step>)
                        })}
                    </Stepper>
            </CardContent>
        </Card>
    )
}

export default StepperForm;